import { render } from "./dpp-button.presentational.vue?vue&type=template&id=ce5b520e"
import script from "./dpp-button.presentational.vue?vue&type=script&lang=js"
export * from "./dpp-button.presentational.vue?vue&type=script&lang=js"

import "./dpp-button.presentational.vue?vue&type=style&index=0&id=ce5b520e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__